import { isArray, mergeWith } from 'lodash'

import { useGetChartSourcesListQuery } from '../graphql/queries/getChartSourcesList.types'
import { DEFAULT_ENTITIES_LIMIT } from 'shared/consts'

export const useChartSources = () => {

  const {
    data,
    error,
    loading,
    previousData,
    fetchMore,
    refetch
  } = useGetChartSourcesListQuery({
    variables: { input: { offset: 0, limit: DEFAULT_ENTITIES_LIMIT } },
    notifyOnNetworkStatusChange: true
  })

  const prevSources = previousData?.getFactSourceItems.items
  const chartSources = data?.getFactSourceItems?.items ?? prevSources ?? []
  const total = data?.getFactSourceItems?.total ?? 0

  const loadMoreChartSources = () => {
    if (!loading) {
      fetchMore({
        variables: {
          input: { offset: chartSources.length, limit: DEFAULT_ENTITIES_LIMIT }
        },

        updateQuery: (prev, { fetchMoreResult, variables: { input } }) => {
          if (!fetchMoreResult) return prev
          return mergeWith(fetchMoreResult, prev, (objValue, srcValue) => {
            if (isArray(objValue)) {
              return [...srcValue, ...objValue]
            }
          })
        }
      })
    }
  }

  return {
    chartSources,
    total,
    loadMoreChartSources,
    fetchMoreSources: fetchMore,
    chartSourcesLoading: loading,
    chartSourcesError: error,
    refetch
  }
}
